import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PopupImage } from 'src/app/models/popup-image';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'image-popup-dialog',
  templateUrl: 'image-popup-dialog.html',
})
// tslint:disable-next-line:component-class-suffix
export class ImagePopupDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ImagePopupDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PopupImage) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
